import { OrderSettings } from 'orderme-api-integration-client';
import { SettingClient } from '../../helpers/client';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SettingsState {
  orderSettings: OrderSettings;
  loaded: boolean;
  deliveryServiceIds: string[];
}

const settingsClient: SettingClient = new SettingClient();

export const loadSettings = createAsyncThunk('settings/load', async (_: void, thunkAPI) => {
  try {
    var settings = await settingsClient.get();
    thunkAPI.dispatch(updateOrderSettings(settings.orders));
  } catch (error) {
    console.error(error);
  }

  return true;
});

const initialState = {
  orderSettings: null,
  deliveryServiceIds: [],
  loaded: false,
} as SettingsState;

const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialState,
  reducers: {
    updateOrderSettings: (state, action: PayloadAction<OrderSettings>) => {
      state.orderSettings = action.payload;
      state.deliveryServiceIds = [
        action.payload.deliveryServiceId,
        action.payload.parcelLockerDeliveryServiceId,
        action.payload.wardrobeDeliveryServiceId,
      ];
    },
    clearSettings: (state) => {
      state.loaded = false;
      state.orderSettings = null;
      state.deliveryServiceIds = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadSettings.fulfilled, (state, _) => {
      state.loaded = true;
    });
    builder.addCase(loadSettings.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadSettings.rejected, (state) => {
      state.loaded = true;
    });
  },
});

export const { updateOrderSettings, clearSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
